import BrowserDetector from '@/scripts/helpers/browser-detector';
import fullscreenHelper from '@/scripts/helpers/fullscreen-helper';
import { VideoPlayerActionContext } from '../types';

type CrossBrowserHTMLVideoElement = HTMLVideoElement & {
  webkitEnterFullscreen?: Function;
  webkitExitFullscreen?: Function;
}

const getVideoElement = (element: HTMLElement): null | CrossBrowserHTMLVideoElement => {
  const [videoElement] = element.getElementsByTagName('video');
  return videoElement;
};

export const exitFullscreen = (context: VideoPlayerActionContext): void => {
  context.commit('set', ['fullscreen', false]);

  // TODO: add a class specific to player to handle full screen interaction. Don't directly override the style
  document.body.style.overflowY = 'initial';

  // Hack for iOS
  if (BrowserDetector.os() === 'iOS') {
    // Get relevant element
    const playerContainer = context.getters.player!.getContainer();
    const documentContext = (playerContainer && playerContainer.parentElement) || document.documentElement;
    // Force video to exit fullscreen
    const videoEl = getVideoElement(documentContext);
    videoEl?.webkitExitFullscreen?.();
    return;
  }
  const handler = context.state.$_internal.externalHandlerMaps.handleChangeEvent;
  fullscreenHelper.removeFullscreenChangeListener(handler);

  // Request exit fullscreen
  fullscreenHelper.exitFullscreen();
};

/**
 * Handle keydown event for escape to exit fullscreen
 */
const handleChangeEvent = (context: VideoPlayerActionContext): void => {
  if (!fullscreenHelper.inFullscreen) {
    exitFullscreen(context);
  }
};

export const requestFullscreen = (context: VideoPlayerActionContext): void => {
  // Get relevant element
  const playerContainer = context.getters.player!.getContainer();
  const documentContext = (playerContainer && playerContainer.parentElement) || document.documentElement;

  // Hack for iOS
  if (BrowserDetector.os() === 'iOS') {
    // Force video to enter fullscreen
    getVideoElement(documentContext)?.webkitEnterFullscreen?.();
    return;
  }

  context.commit('set', ['fullscreen', true]);

  // TODO: add a class specific to player to handle full screen interaction. Don't directly override the style
  document.body.style.overflowY = 'hidden';

  // Set up event handler
  const handler = handleChangeEvent.bind(null, context);
  context.state.$_internal.externalHandlerMaps.handleChangeEvent = handler;

  fullscreenHelper.addFullscreenChangeListener(handler, false);

  // Request enter fullscreen
  fullscreenHelper.requestFullscreen(documentContext);
};
